module.exports = __webpack_public_path__ + "static/media/2--mobile.7708708c.webp";